import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Registration } from '@models';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'app-vessel-registration-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    ReactiveFormsModule,
  ],
})
export class VesselRegistrationFormComponent {
  isEdit = signal<boolean>(false);
  dialogRef = inject<MatDialogRef<VesselRegistrationFormComponent>>(MatDialogRef);
  currentYear = signal(new Date().getUTCFullYear());
  registration = inject<Registration | undefined>(MAT_DIALOG_DATA);

  code = new FormControl(this.registration?.code, { validators: [Validators.required] });
  year = new FormControl(this.registration?.year, {});

  registrationForm = new FormGroup({
    code: this.code,
    year: this.year,
  });

  submit() {
    if (this.registrationForm.pristine || !this.registrationForm.valid) { return };

    const data = {
      code: this.registrationForm.value.code?.trim(),
      year: this.registrationForm.value.year ? this.registrationForm.value.year : undefined,
    } as Registration;

    this.dialogRef.close(data);
  }

  cancel() {
    this.dialogRef.close();
  }

}
